<template>
  <div
    class="timeline--connector align-center"
    data-aos="zoom-in"
    data-aos-once="false"
  />
</template>

<script>
export default {
  name: "Connector",
  props: ["connectorHeight"],
};
</script>
